module.exports = __webpack_public_path__ + "static/img/head.673abd18.png";